// @ts-nocheck

/**
 * * `newborn` - Newborn (0-12 months)
 * `toddler` - Toddler (0-3)
 * `child` - Child (3-6)
 * `parent` - Parent (Adult)
 */
export type AgeGroupEnum = typeof AgeGroupEnum[keyof typeof AgeGroupEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgeGroupEnum = {
  newborn: "newborn",
  toddler: "toddler",
  child: "child",
  parent: "parent",
} as const;
